module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-setting"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "bg-white min-height"
  }, [_c('home-sidebar', {
    attrs: {
      "active_item": "setting"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "bg-white min-height ml-3"
  }, [_c('div', {
    staticClass: "pt-3"
  }, [_c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "status-icon": "",
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.userForm.name),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "name", $$v)
      },
      expression: "userForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.userForm.email),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "email", $$v)
      },
      expression: "userForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话号码",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    model: {
      value: (_vm.userForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "phone", $$v)
      },
      expression: "userForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生日期"
    }
  }, [_c('el-date-picker', {
    staticClass: "item_w",
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.userForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "birthday", $$v)
      },
      expression: "userForm.birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          model: {
            value: (_vm.userForm.sex),
            callback: function($$v) {
              _vm.$set(_vm.userForm, "sex", $$v)
            },
            expression: "userForm.sex"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": "1"
          }
        }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": "0"
          }
        }, [_vm._v("女")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通讯地址"
    }
  }, [_c('el-input', {
    staticClass: "item_w1",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.userForm.address),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "address", $$v)
      },
      expression: "userForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确定修改\n                ")])], 1)], 1)], 1)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d33e21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/Setting.vue
// module id = 272
// module chunks = 1